// https://github.com/fcannizzaro/react-use-cookie-watcher/blob/master/src/index.tsx

import { useEffect, useState } from 'react';

// Get the cookie value by name
const getCookie = (name) => {
  const match = document.cookie.match(`(?:^|.*)${name}=(.+?)(?:$|[|;].*)`);
  return match ? match[1] : undefined;
};

const useCookieWatcher = (name, options) => {
  // Create default options
  const hookOptions = Object.assign(
    {
      checkEvery: 250
    },
    options ?? {}
  );

  // State for cookie existence
  const [cookie, setCookie] = useState(getCookie(name));

  // Check for cookie existence every `checkEvery` milliseconds
  useEffect(() => {
    const interval = window.setInterval(
      () => setCookie(getCookie(name)),
      hookOptions.checkEvery
    );
    return () => window.clearInterval(interval);
  }, [name, hookOptions.checkEvery]);

  return cookie;
};

export { useCookieWatcher };
